import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextInsertField from './../../components/TextInsertField';
import ComboBoxInsertField from './../../components/ComboBoxInsertField';
import MunkabeosztasIrszField from './../../componentsSpecial/MunkabeosztasIrszField';
import MunkabeosztasTelepulesCombo from './../../componentsSpecial/MunkabeosztasTelepulesCombo';
import NumberInsertField from './../../components/NumberInsertField';
import TextAreaInsertField from './../../components/TextAreaInsertField';


class MunkaBeosztasCimekUpdate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            munkaBeosztasCimek_id: ''
            , munkaBeosztasCimek_munka_beosztas_id: ''
            , munkaBeosztasCimek_ugyfel_id: ''
            , munkaBeosztasCimek_irsz: ''
            , munkaBeosztasCimek_telepules: ''
            , munkaBeosztasCimek_telepulesNev: ''
            , munkaBeosztasCimek_cim: ''
            , munkaBeosztasCimek_megjegyzes: ''

        }


        this.references = [];
        this.references['munkaBeosztasCimek_id'] = React.createRef();
        this.references['munkaBeosztasCimek_munka_beosztas_id'] = React.createRef();
        this.references['munkaBeosztasCimek_ugyfel_id'] = React.createRef();
        this.references['munkaBeosztasCimek_irsz'] = React.createRef();
        this.references['munkaBeosztasCimek_telepules'] = React.createRef();
        this.references['munkaBeosztasCimek_cim'] = React.createRef();
        this.references['munkaBeosztasCimek_megjegyzes'] = React.createRef();


        this.validators = [];
        this.validators['munkaBeosztasCimek_id'] = {fieldName: 'munkaBeosztasCimek_id', dataType: 'INT', value: this.state.munkaBeosztasCimek_id, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_munka_beosztas_id'] = {fieldName: 'munkaBeosztasCimek_munka_beosztas_id', dataType: 'INT', value: this.state.munkaBeosztasCimek_munka_beosztas_id, mandatory: true, min: null, max: null};
        this.validators['munkaBeosztasCimek_ugyfel_id'] = {fieldName: 'munkaBeosztasCimek_ugyfel_id', dataType: 'INT', value: this.state.munkaBeosztasCimek_ugyfel_id, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_irsz'] = {fieldName: 'munkaBeosztasCimek_irsz', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_irsz, mandatory: true, min: null, max: null};
        this.validators['munkaBeosztasCimek_telepules'] = {fieldName: 'munkaBeosztasCimek_telepules', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_telepules, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_telepulesNev'] = {fieldName: 'munkaBeosztasCimek_telepulesNev', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_telepulesNev, mandatory: false, min: null, max: null};
        this.validators['munkaBeosztasCimek_cim'] = {fieldName: 'munkaBeosztasCimek_cim', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_cim, mandatory: true, min: null, max: null};
        this.validators['munkaBeosztasCimek_megjegyzes'] = {fieldName: 'munkaBeosztasCimek_megjegyzes', dataType: 'VARCHAR', value: this.state.munkaBeosztasCimek_megjegyzes, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

        this.load();

    }

    componentDidMount() {
        //this.setFocusedComponent();
    }

    setFocusedComponent = function () {
        try {
            for (var i = 0; i < Object.keys(this.references).length; i++) {
                let first = Object.keys(this.references)[i];

                if (this.references[first].current != null && typeof this.references[first].current.focus != 'undefined') {
                    this.references[first].current.focus();
                    return false;
                }
            }
        } catch (e) {
            console.log("can not set focus on first component");
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.load();
        }
    }

    reset = function () {

        this.setState({munkaBeosztasCimek_id: ''
            , munkaBeosztasCimek_munka_beosztas_id: ''
            , munkaBeosztasCimek_ugyfel_id: ''
            , munkaBeosztasCimek_irsz: ''
            , munkaBeosztasCimek_telepules: ''
            , munkaBeosztasCimek_telepulesNev: ''
            , munkaBeosztasCimek_cim: ''
            , munkaBeosztasCimek_megjegyzes: ''
        });
    }

    loadUgyfelCim = function (ugyfel_id) {
        try {
            const url = ajax.getUrlBase() + "modules/UgyfelCimekKarbantartas/ugyfelCimSuggestion.php";
            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({ugyfel_id: ugyfel_id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        var data = response.data;
                        this.setState({
                            munkaBeosztasCimek_irsz: data.ugyfelCimek_irsz
                            , munkaBeosztasCimek_telepules: data.ugyfelCimek_telepulesNev
                            , munkaBeosztasCimek_telepulesNev: data.ugyfelCimek_telepulesNev
                            , munkaBeosztasCimek_cim: data.ugyfelCimek_cim
                        });
                        
                        
                    }).catch(function (jsonError) {
                        if (null == jsonError) {
                            console.error("Fetch JSON error:");
                        } else {
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                console.error("Fetch error:", error);
                if (null == error) {
                    console.error("Fetch error:");
                } else {
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            console.error("Fetch exception:", String(ex));
        }
    }

    setBack = function (id, value) {

        if (id == "munkaBeosztasCimek_ugyfel_id") {
            if (isNaN(value) == false) {
                this.loadUgyfelCim(value);
            }
        }
        this.setState({[id]: value});
    }

    getForm = function () {
        return <Container>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_ugyfel_id')}</Col>
                <Col style={{textAlign: 'right'}}>
                <ComboBoxInsertField 
                    id={'munkaBeosztasCimek_ugyfel_id'} 
                    value={this.state.munkaBeosztasCimek_ugyfel_id}  
                    setBack={this.setBack.bind(this)}
                    dataSourceUrl={'modules/MunkaBeosztasCimek/ugyfel_idFormComboInsertData.php'}
                    reference={this.references['munkaBeosztasCimek_ugyfel_id']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_irsz')}</Col>
                <Col style={{textAlign: 'right'}}>
                <MunkabeosztasIrszField 
                    id={'munkaBeosztasCimek_irsz'} 
                    value={this.state.munkaBeosztasCimek_irsz}  
                    setBack={this.setBack.bind(this)}
                    dataSourceUrl={'modules/MTOMunkaBeosztasCimek/irsz_FromComboInsertData.php'}
                    reference={this.references['munkaBeosztasCimek_irsz']}
                    editable={true}
                    theme={this.props.theme}
                    telepulesAttrName={"munkaBeosztasCimek_telepules"}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_telepules')}</Col>
                <Col style={{textAlign: 'right'}}>
                <MunkabeosztasTelepulesCombo 
                    id={'munkaBeosztasCimek_telepules'} 
                    value={this.state.munkaBeosztasCimek_telepulesNev}  
                    setBack={this.setBack.bind(this)}
                    dataSourceUrl={'modules/MunkaBeosztasCimek/telepules_FromComboUpdateData.php'}
                    reference={this.references['munkaBeosztasCimek_telepules']}
                    editable={true}
                    theme={this.props.theme}
                    irsz={this.state.munkaBeosztasCimek_irsz}
        
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_cim')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'munkaBeosztasCimek_cim'} 
                    value={this.state.munkaBeosztasCimek_cim}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['munkaBeosztasCimek_cim']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('munkaBeosztasCimek_megjegyzes')}</Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'right'}}>
                <TextAreaInsertField 
                    id={'munkaBeosztasCimek_megjegyzes'} 
                    value={this.state.munkaBeosztasCimek_megjegyzes}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['munkaBeosztasCimek_megjegyzes']}
                    editable={true}   
                    theme={this.props.theme}
                    style={{minWidth: '100%'}}
                    />
                </Col>
            </Row>
        
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }
        return this.state;
    }

    update = function (e) {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }

        var method = e.target.id;
        var self = this;

        this.concatAdditionalParams();

        try {
            const url = ajax.getUrlBase() + "modules/MunkaBeosztasCimek/munkaBeosztasCimekFormUpdate.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify(this.state)
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            self.transactionSuccess();
                            if (method == 'save') {
                                self.closeForm();
                            }
                            if (method == 'save_new') {
                                self.reset();
                            }
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {

                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {

                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {

                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {

            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    load = function () {

        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/MunkaBeosztasCimek/munkaBeosztasCimekFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({id: this.props.id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            this.setState(response.data[0]);
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        self.defaultUpdateBlocked = false;
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    self.defaultUpdateBlocked = false;
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                self.defaultUpdateBlocked = false;
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            self.defaultUpdateBlocked = false;
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{maxHeight: 600}}>
            <div className={'popupWrapper' + className} id="MunkaBeosztasCimekUpdate">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('MunkaBeosztasCimekUpdate')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.update.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('save')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default MunkaBeosztasCimekUpdate;

